(function ($) {
  var _utilsSvc = epi.EPiServer.Forms.Utils,
    originalGetCustomElementValue = epi.EPiServer.Forms.Extension.getCustomElementValue,
    originalBindCustomElementValue = epi.EPiServer.Forms.Extension.bindCustomElementValue,
    language = navigator.language || navigator.userLanguage; // on iOS naviagtor.language is in lower case (ex: en-us);


  // extend the EpiForm JavaScript API in ViewMode
  $.extend(true, epi.EPiServer.Forms, {
    /// extend the Validator to validate Visitor's value in Clientside.
    /// Serverside's Fullname of the Validator instance is used as object key (Case-sensitve) to lookup the Clientside validate function.        
    Validators: {
      "Fidelity.Web.Business.Validation.GoogleRecaptchaValidator": function (fieldName, fieldValue, validatorMetaData) {

        // validate recaptcha element
        if (fieldValue) {
          return { isValid: true };
        }

        return { isValid: false, message: validatorMetaData.model.message };
      }
    },
    Extension: {
      // OVERRIDE, process to get value from datetime picker element
      getCustomElementValue: function ($element) {

        // for datetime picker we always return result in format "2015-12-25 10:30 AM",
        // and depend on picker type (date/time/datetime) we will parse its value later.
        if ($element.hasClass("FormRecaptcha")) {
          // for recaptcha element
          var widgetId = $element.data("epiforms-recaptcha-widgetid");
          if (widgetId != undefined && grecaptcha) {
            return grecaptcha.getResponse(widgetId);
          } else {
            return null;
          }
        }

        // if current element is not our job, let others process
        return originalGetCustomElementValue.apply(this, [$element]);
      }
    }
  });

})($$epiforms || $);


(function ($) {
  var _utilsSvc = epi.EPiServer.Forms.Utils;
  $(".EPiServerForms").on("formsReset formsNavigationPrevStep", function (event) {
    resetRecaptchaElements(event.target);
  });

  $(".EPiServerForms").on("formsStepValidating", function (event) {
    if (event.isValid == true) {
      return;
    }
    // reset reCAPTCHA element if validation failed
    resetRecaptchaElements(event.target);
  });


  // reset reCAPTCH elements in target form
  function resetRecaptchaElements(target) {

    var reCaptchaElements = $(".FormRecaptcha", target);
    $.each(reCaptchaElements, function (index, element) {
      var widgetId = $(element).data("epiforms-recaptcha-widgetid");
      if (widgetId != undefined && grecaptcha) {
        grecaptcha.reset(widgetId);
      }
    });
  };

})($$epiforms || $);

function initRecaptchaElements() {
  (function ($) {

    //This is the callback function executed after Google authenticates recaptcha values.
    function onVerify($element) {
      return function () {
        return function (response) {
          if (!response || response.length == 0) {
            return;
          };

          $element.find(".Form__Element__ValidationError").hide();
        }
      }($element);
    };

    $(".Form__Element.FormRecaptcha").each(function (index, element) {
      var $element = $(element),
        $widgetContainer = $(".g-recaptcha", $element),
        siteKey = $element.data("epiforms-sitekey");
      if ($widgetContainer.length == 1 && siteKey) {
        var widgetId = grecaptcha.render($widgetContainer.get(0), { sitekey: siteKey, callback: onVerify($element) });
        $element.data("epiforms-recaptcha-widgetid", widgetId.toString());
      }
    });

  })($$epiforms || $);
}
